// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_3o-nj","trueRow":"style_trueRow_2Vlcy","fz30":"style_fz30__ICgL"};